<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Cost Estimation</li>
    </ol>
  </nav>

  <div class="row">
    <div class="col">
      <div class="inner-box p-4">
        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group">
              <label class="control-label">Pickup Area Pincode</label>
              <input type="text" id="pickUp" class="form-control" (blur)="typePickUpPinCode()"
                     [ngClass]="{'is-invalid':pickUpPinCodeError}" appOnlyNumbers [(ngModel)]="pickUpPinCode"
                     [ngModelOptions]="{standalone: true}" placeholder="Pickup Pincode" required>
              <div id="pickUpPinCodeError" class="invalid-feedback d-block shift-invalid-login"
                   [hidden]="!pickUpPinCodeError" style="position: absolute;">{{pickUpPinCodeError}}
              </div>
            </div>
          </div>

          <div class="col-md-4 required">
            <div class="form-group">
              <label class="control-label" for="deliveryPinCode">Delivery Area Pincode</label>
              <input type="text" id="deliveryPinCode" class="form-control" appOnlyNumbers (blur)="typeDeliveryPinCode()"
                     [ngClass]="{'is-invalid':deliveryPinCodeError}" [(ngModel)]="deliveryPinCode"
                     [ngModelOptions]="{standalone: true}" placeholder="Delivery Pincode" required>
              <div id="deliveryPinCodeError" class="invalid-feedback d-block shift-invalid-login"
                   [hidden]="!deliveryPinCodeError" style="position: absolute;">{{deliveryPinCodeError}}
              </div>
            </div>
          </div>

          <div class="col-md-4 required">
            <div class="form-group">
              <label class="control-label" for="deliveryPinCode">Carriers</label>
              <div class="form-group">

                <ng-multiselect-dropdown
                  [data]="['Delhivery','Gati','Dotzot','Shadow Fax','Blue Dart','Dunzo','Xpressbees', 'KerryExpress' ,'Whizzy','EcomXpress Pro', 'EcomXpress EGS']"
                  [settings]="dropdownSettings"
                  [(ngModel)]="carriers">
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-md-4 required">
            <div class="form-group">
              <label class="control-label">Approximate Weight (kg)</label>
              <input type="text" id="weight" class="form-control" appOnlyNumbers (blur)="typeWeight()"
                     [ngClass]="{'is-invalid':weightError}" [(ngModel)]="weight" [ngModelOptions]="{standalone: true}"
                     placeholder="Weight" required>
              <div id="weightError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!weightError"
                   style="position: absolute;">{{weightError}}
              </div>
            </div>
          </div>

          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label">Dimensions (cm)</label>
              <div class="row">
                <div class="col-4">
                  <input type="text" id="l" class="form-control" (blur)="typeLength()"
                         [ngClass]="{'is-invalid':lengthError}" [(ngModel)]="length" appOnlyNumbers
                         [ngModelOptions]="{standalone: true}" placeholder="L" required>
                  <div id="lengthError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!lengthError"
                       style="position: absolute;">{{lengthError}}
                  </div>
                </div>
                <div class="col-4">
                  <input type="text" id="w" class="form-control" (blur)="typeWidth()"
                         [ngClass]="{'is-invalid':widthError}" [(ngModel)]="width" appOnlyNumbers
                         [ngModelOptions]="{standalone: true}" placeholder="W" required>
                  <div id="widthError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!widthError"
                       style="position: absolute;">{{widthError}}
                  </div>
                </div>
                <div class="col-4">
                  <input type="text" id="h" class="form-control" (blur)="typeHeight()"
                         [ngClass]="{'is-invalid':heightError}" [(ngModel)]="height" appOnlyNumbers
                         [ngModelOptions]="{standalone: true}" placeholder="H" required>
                  <div id="heightError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!heightError"
                       style="position: absolute;">{{heightError}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row required">

          <div class="col-md-4 required">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" (click)="onClick()" id="paymentMethod"
                     [(ngModel)]="paymentMethod" [ngModelOptions]="{standalone: true}">
              <label class="form-check-label" for="paymentMethod">COD order</label><br>
              <span *ngIf="paymentMethod"
                    ngbTooltip="Additional Charges for COD Rs40/- or 1.5% whichever is higher will be charged extra. Charges may differ for few carriers."><small>Additional Charges for COD Rs40/- or 1.5%...</small></span>
            </div>
          </div>
          <div class="col-4 required" [class.d-none]="cod == 'N'">
            <div class="form-group ">
              <input type="text" id="v" class="form-control" (blur)="typeValue()" [ngClass]="{'is-invalid':valueError}"
                     [(ngModel)]="orderValue" appOnlyNumbers [ngModelOptions]="{standalone: true}"
                     placeholder="Please enter COD amount" required>
              <div id="valueError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!valueError"
                   style="position: absolute;">{{valueError}}
              </div>
            </div>
          </div>
         <!-- <div class="col-4 required" [class.d-none]="cod == 'N'">
          <div  class="form-group " >
            <input type="text" id="v" class="form-control"  (blur)="typeValue()" [ngClass]="{'is-invalid':valueError}" [(ngModel)]="orderValue" appOnlyNumbers [ngModelOptions]="{standalone: true}" placeholder="Please enter COD amount" required>
            <div id="valueError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!valueError" style="position: absolute;">{{valueError}}</div>
          </div>
          </div>-->
        </div>


        <div class="mt-3">
          <div class="table-3" style="overflow-x:auto;">
            <table class="table packing-table packing-table-2">
              <thead class="thead-light">
              <tr>
                <th></th>
                <th>Courier Partner</th>
                <th>Courier Mode</th>
                <th>Price</th>
                <th>Pickup Available</th>
              </tr>
              </thead>
              <tbody *ngFor="let co of costEstimation; let i=index;">
              <tr *ngFor="let c of co.costEstimates; let j=index;">
                <td><img src="assets/images/1-{{co.carrierCode}}.png" style="height: 18px; width: 18px;"></td>
                <td>
                  {{(co.carrierCode == 'SD' ? 'Shift' :
                  (co.carrierCode == 'DL' ? 'Delhivery' :
                  (co.carrierCode == 'GT' ? 'Gati' :
                  (co.carrierCode == 'DZ' ? 'Dotzot' :
                  (co.carrierCode == 'RD' ? 'Rapid Delivery' :
                  (co.carrierCode == 'SF' ? 'Shadow Fax' :
                  (co.carrierCode == 'BD' ? 'Blue Dart' :
                  (co.carrierCode == 'PR' ? 'Pickrr' :
                  (co.carrierCode == 'SY' ? 'Ship Yaari' :
                  (co.carrierCode == 'DE' ? 'Delhivery' :
                  (co.carrierCode == 'SG' ? 'Shippigo' :
                  (co.carrierCode == 'VS' ? 'Vamaship' :
                  (co.carrierCode == 'DN' ? 'Dunzo' :
                  (co.carrierCode == 'XB' ? 'Xpressbees' :
                  (co.carrierCode == 'KE' ? 'Kerry Express' :
                  (co.carrierCode == 'EX' ? 'EcomExpress Pro' :
                  (co.carrierCode == 'EG' ? 'EcomXpress EGS' :
                  (co.carrierCode == 'FE' ? 'FedEx' : co.carrierCode))))))))))))))))))}}
                  <div *ngIf="c.shippingPreference != ''" style="display: inline-flex;" class="ml-2">
                    {{c.shippingPreference}}
                  </div>
                </td>
                <td>
                  <div *ngIf="c?.deliveryMode && c?.serviceType">
                    {{c.deliveryMode + '/' + (c.serviceType || " ") | replaceStatus}}
                  </div>
                  <div *ngIf="c?.serviceType">{{c.serviceType | replaceStatus}}</div>
                  <div *ngIf="c?.deliveryMode">{{c.deliveryMode | replaceStatus}}</div>
                  <div>{{c.courier}}</div>
                </td>
                <td>{{c.totalAmount | currency:'INR'}}</td>
                <td>{{"Yes"}}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr *ngIf="costEstimation?.length ===0 || !costEstimation?.length">
                <td [attr.colspan]="6" class="text-center">No Carriers available to serve the Order</td>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="cancel" class="btn btn-cancel">Cancel</button>
      <button type="submit" (click)="submitCostEstimation()" class="btn btn-orange ml-2">Submit</button>
    </div>
  </div>
</div>
